<template>
  <div>
    <div class="d-flex align-items-center mt-1 w-100" v-if="errors[0]">
      <img src="@/assets/svg/error-field.svg" alt="" class="mr-1" />
      <span class="error-field text-danger">{{ errors[0] }}</span>
    </div>
    <div
      class="d-flex align-items-center mt-1 w-100"
      v-else-if="message !== ''"
    >
      <img src="@/assets/svg/error-field.svg" alt="" class="mr-1" />
      <span class="error-field text-danger">{{ message }}</span>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    errors: {
      type: [Array],
      default: () => [],
    },
    message: {
      type: String,
      default: () => "",
    },
  },
};
</script>
<style scoped>
.error-field {
  font-size: 12px !important;
  line-height: 14px !important;
}
</style>